// extracted by mini-css-extract-plugin
export default {"root":"IconVideoPlayer_root__a37-8"};